import React, { useState, useEffect } from "react";
import { Page, Grid, Card } from "tabler-react";
import SiteWrapper from "../../SiteWrapper";
import * as productServices from "../../store/services/productServices";
import { BACKENDURL } from "../../store/services/type";

function CustomerProducts(props) {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        setLoading(true);
        productServices
            .getRecommendedProducts()
            .then((res) => {
                const data = JSON.parse(res.data);
                setProducts(data?.data || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header">
                    <h1 className="page-title">Recommended Products</h1>
                </div>

                {products.length > 0 ? (
                    <Grid.Row>
                        {products.map((product, index) => (
                            <Grid.Col key={index} xl={4} md={6} width={12} className="mb-4">
                                <div
                                    onClick={() => props.history.push(`/my-products/${product.id}`)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <Card className="mb-0" style={{ border: "1px solid #e0e0e0", borderRadius: 12, overflow: "hidden" }}>
                                        <div style={{ aspectRatio: "1 / 1", borderRadius: "12px 12px 0 0", overflow: "hidden", backgroundColor: "#f6f6f6" }}>
                                            {product?.images?.length > 0 ? (
                                                <img
                                                    src={`${BACKENDURL}storage/${product.images[0]}`}
                                                    alt={product.product}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                                                />
                                            ) : (
                                                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#B3B3B3" strokeWidth="1.5">
                                                        <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        <Card.Body style={{ padding: "16px 18px 20px" }}>
                                            {product?.category?.category && (
                                                <div className="pc-category">
                                                    {product.category.category}
                                                </div>
                                            )}
                                            <div className="pc-name">
                                                {product.product}
                                            </div>
                                            {product?.unique_id && (
                                                <div className="pc-sku">
                                                    SKU: {product.unique_id}
                                                </div>
                                            )}
                                            {product?.price && (
                                                <div className="pc-price">
                                                    £{product.price}
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Grid.Col>
                        ))}
                    </Grid.Row>
                ) : (
                    <Grid.Row>
                        <Grid.Col>
                            <Card>
                                <Card.Body className="align-items-center justify-content-center text-center" style={{ padding: "60px 20px" }}>
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#B3B3B3" strokeWidth="1.5" style={{ marginBottom: 16 }}>
                                        <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                                    </svg>
                                    <h4 style={{ color: "#2E2E2E", marginBottom: 8 }}>No Recommended Products</h4>
                                    <p style={{ color: "#B3B3B3", margin: 0 }}>
                                        In order to see recommended products you need a measurement and dealer association.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Grid.Col>
                    </Grid.Row>
                )}
            </Page.Content>
        </SiteWrapper>
    );
}

export default CustomerProducts;
